module.exports = __webpack_public_path__ + "img/logo.49d3dd8d.svg";